import React from 'react'
import styles from './HeroBanner.module.css'
import promoImg from '../../assets/images/IMG_0068.png'
import appStore from '../../assets/images/appStore.png'
import playStore from '../../assets/images/playStore.png'
const HeroBanner = () => {

  const redirectToAppStore = () => {
    // Replace 'your-ios-app-id' with your actual iOS app ID
    const iOSAppId = 'com.cricway.app';
    const appStoreUrl = `https://apps.apple.com/app/id${iOSAppId}`;
    window.location.href = appStoreUrl;
  };

  const redirectToPlayStore = () => {
    // Replace 'your-android-package-name' with your actual Android package name
    const androidPackageName = 'com.cricway.app';
    const playStoreUrl = `https://play.google.com/store/apps/details?id=${androidPackageName}`;
    window.location.href = playStoreUrl;
  };

  return (
    <div className={styles.heroBanner}>
      <div className={styles.appStore} onClick={redirectToAppStore}><img src={appStore} alt="" /></div>

      <div className={styles.playStore} onClick={redirectToPlayStore}><img src={playStore} alt="" /></div>
        <img src={promoImg} alt="" />
      </div>
  )
}

export default HeroBanner
